var exports = {
  "J": "LabelColorIndicator__Jv_C7I",
};

module.exports = exports;
